// components/NoDeploymentsMessage.js
import React from "react";
// import NightSky from './NightSky';

const NoDeploymentsMessage = ({ Message }) => (
  <>
    {/* <NightSky /> */}
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "calc(100vh - 250px)",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <div style={{ color: "whitesmoke", textAlign: "center", width: "100%" }}>
        <h2>{Message}</h2>
        <img width="200px" alt="logo" src="JimmyBot.png" />
      </div>
    </div>
  </>
);

export default NoDeploymentsMessage;
